import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

const IntroScreenContent = () => {
  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'lightningIntro',
  });

  return (
    <View>
      <BodyBaseText numberOfLines={0} style={styles.title}>
        {translatedText('secondaryText')}
      </BodyBaseText>
      <ListItem
        primaryCopy={translatedText('flatFee')}
        showsChevron={false}
        leadingAccessory={{
          id: 'FLASH_ON_within_minutes',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'FLASH_ON',
          },
        }}
      />
      <View style={styles.hairLine}>
        <HairLineDivider />
      </View>
      <ListItem
        primaryCopy={translatedText('noCreditCheck')}
        showsChevron={false}
        leadingAccessory={{
          id: 'NO_CREDIT_SCORE_IMPACT',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'CREDIT_SCORE',
          },
        }}
      />
      <View style={styles.hairLine}>
        <HairLineDivider />
      </View>
      <ListItem
        primaryCopy={translatedText('flexibleRepayment')}
        showsChevron={false}
        leadingAccessory={{
          id: 'SUN_zero_interest',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'SUN',
          },
        }}
      />
      <View style={styles.hairLine}>
        <HairLineDivider />
      </View>
      <BodyXSText style={styles.termsApply} numberOfLines={0}>
        {translatedText('termsAndConditions')}
      </BodyXSText>
    </View>
  );
};

const styles = StyleSheet.create({
  hairLine: {
    marginHorizontal: theme.spacing.m,
  },
  termsApply: {
    color: theme.color.text.secondary,
    padding: theme.spacing.m,
  },
  title: {
    backgroundColor: theme.color.background.primary,
    paddingHorizontal: theme.spacing.m,
    textAlign: 'center',
  },
});

export default IntroScreenContent;
